import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularPinUp: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_pin-up"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="pin-up icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 16 17"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M4.3618 11.7764L7.55279 5.39443C7.73705 5.0259 8.26295 5.0259 8.44721 5.39443L11.6382 11.7764C11.8044 12.1088 11.5627 12.5 11.191 12.5H4.80902C4.43733 12.5 4.19558 12.1088 4.3618 11.7764Z" />
      </svg>
    </span>
  );
};

export { RegularPinUp };
